export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: [
        { label: '国产电视剧全集', href: '#index' },
        { label: '韩剧完整版', href: '#index' },
        { label: '美剧在线全集', href: '#index' },
        { label: '日剧大结局', href: '#index' },
      ],
    },
    {
      title: '快速入口',
      links: [
        { label: '热播推荐', href: '#cards' },
        { label: '追剧榜单', href: '#ranking' },
        { label: '专题推荐', href: '#carousel' },
        { label: '最新动态', href: '#updates' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '常见问题', href: '#faq' },
        { label: '联系我们', href: '#contact' },
        { label: '平台优势', href: '#features' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-foreground-50 text-base mb-4">
                  {col.title}
                </h4>
                {col.links.length > 0 ? (
                  <ul className="flex flex-col gap-2.5">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          onClick={(e) => {
                            e.preventDefault();
                            handleClick(link.href);
                          }}
                          className="text-foreground-400 text-sm hover:text-primary-400 cursor-pointer transition-colors duration-200"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-foreground-500 text-sm">敬请期待</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2.5">
              <div className="w-7 h-7 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-foreground-50 text-xs"></i>
              </div>
              <span className="font-heading text-foreground-200 text-lg">萝卜影视</span>
            </div>
            <p className="text-foreground-500 text-xs md:text-sm">
              萝卜影视收录电视剧全集、连续剧完整版及电视剧大结局，在线全集免费看，高清播放不缓冲。
            </p>
            <p className="text-foreground-600 text-xs whitespace-nowrap">
              &copy; {new Date().getFullYear()} 萝卜影视 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}